import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, } from "react-redux";
import { toggleReload } from "../../../src/taskpane/redux/modules/reload";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { ArrowClockwise20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/ArrowClockwise20Regular";

export function useMenuItem_Refresh() {
    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();

    const menuItem_Refresh = React.useMemo(() => {
        return {
            key: "refresh",
            // iconProps: { iconName: "Refresh" },
            iconProps: {},
            onRenderIcon: () => <ArrowClockwise20Regular className={menuItemIconStyles} />,
            iconOnly: true,
            tooltipHostProps: {
                content: <span>{languageStrings.Refresh}</span>,
            },
            onClick: () => {
                dispatch(toggleReload());
            }
        } as IContextualMenuItem;
    }, []);

    return {
        menuItem_Refresh
    }

}